import { createContext } from "react"

const InReviewModeContext = createContext(false)

export default InReviewModeContext
